import React from 'react';
import { WithIcon } from './WithIcon';

export const IconExplore = WithIcon(
  'Explore',
  '0 0 30 30',
  <>
    <path d="M27,3.45a8.71,8.71,0,0,0-14.81,7.14c0,.1,0,.21,0,.31l1.44-.56a7.22,7.22,0,1,1,6.2,6.38l-.57,1.43A8.69,8.69,0,0,0,27,3.45Z" />
    <path d="M18.27,11,2.19,17.31a.75.75,0,0,0-.25,1.23,1.33,1.33,0,0,0,.19.14L7.7,21.45,1.25,27.91,2.31,29l6.5-6.5,2.73,5.61a.76.76,0,0,0,.7.42.75.75,0,0,0,.67-.48L19.24,12A.78.78,0,0,0,18.27,11ZM12.14,25.89,9.74,21a.7.7,0,0,0-.34-.34L4.31,18.09,17.21,13Z" />
  </>
);
